import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const September = () => {
    return (
        <Fragment>{SkipDays(2, 3, [1, 2, 3, 4, 5, 6])}</Fragment>  
    )
}